import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "@store/redux";
import { RecoilRoot } from "recoil";
import "virtual:svg-icons-register";
import "@/initial.scss";
import "@/assets/font/iconfont.css";
import "animate.css";
import App from "@/App";
import "@babel/polyfill";
import "@/styles/index.scss";
import "virtual:uno.css";
// @ts-ignore // 只有小米需要加监控
import "./apm.ts";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/index.ts";

useGoogleAdScript();
if (isDevEnv) {
  import("vconsole").then(VConsole => {
    new VConsole.default();
  });
}
ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <RecoilRoot>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </RecoilRoot>
  // </React.StrictMode>
);
